<p>get-packers-movers-config works!</p>
